import React, { useContext, useEffect, useState } from 'react';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar';
import { CarrierGroupDetailOutDTO } from '@api/ringil-api.v2';
import { ApiContext } from '@api/api';
import { useTranslation } from 'react-i18next';
import InputLayout from '@components/obsolete/Form/InputLayout/InputLayout.tsx';
import InputWrapper from '@components/obsolete/Form/InputWrapper/InputWrapper.tsx';

interface ComponentProps {
  carrierGroupId?: string;
  visible: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const CreateOrUpdateCarrierGroup: React.FC<ComponentProps> = ({ carrierGroupId, visible, onHide, onSuccess }) => {
  const { t } = useTranslation('common');
  const { cuCreateCarrierGroup, cuDetailCarrierGroup } = useContext(ApiContext);
  const [carrierGroup, setCarrierGroup] = useState<CarrierGroupDetailOutDTO>(undefined);

  useEffect(() => {
    if (visible) {
      if (carrierGroupId) {
        cuDetailCarrierGroup(carrierGroupId, data => {
          setCarrierGroup(data);
        });
      } else {
        setCarrierGroup({ carrierGroupName: null, carrierGroupId });
      }
    }
  }, [visible]);

  // FIXME: edit TBD @JakubElias
  const saveOrUpdateCarrierGroup = () => {
    cuCreateCarrierGroup(
      {
        carrierGroupName: carrierGroup.carrierGroupName,
      },
      () => {
        onSuccess();
      },
    );
  };

  return (
    <>
      {/*
        // @ts-ignore*/}
      <RingilSidebar
        visible={visible}
        size={'md'}
        heading={t(`CreateOrUpdateCarrierGroup.createANewCarrierGroup`, `Create a new carrier group`)}
        onContinue={() => saveOrUpdateCarrierGroup()}
        onBack={onHide}
        continueLabel={t(`CreateOrUpdateCarrierGroup.create`, `Create`)}
      >
        {carrierGroup && (
          <>
            <InputLayout>
              <InputWrapper
                label={t(`CreateOrUpdateCarrierGroup.carrierGroupName`, `Carrier group name`)}
                type="text"
                classNameWrapper="p-col-12 p-md-6"
                value={carrierGroup.carrierGroupName}
                onChange={e =>
                  setCarrierGroup({
                    carrierGroupName: (e.target as HTMLInputElement).value,
                    carrierGroupId,
                  })
                }
                error="Hodnota musí být zadána"
                required={true}
              />
            </InputLayout>
          </>
        )}

      </RingilSidebar>
    </>
  );
};

export default CreateOrUpdateCarrierGroup;
